import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { GatewayStatsSummary } from '../../Payments/services';


const options: ApexOptions = {
    chart: {
      type: 'radialBar',
      height: 350,
    },
    colors: ['#163A5D', '#0000FF', '#FF0000', '#309B47'],
    plotOptions: {
      radialBar: {
        dataLabels: {
          total: {
            show: true,
            label: 'Total',
            color: '#FFFFFF',
            fontSize: '15px',
            fontWeight: 'bold',
          },
        },
        hollow: {
          size: '50%',
        },
        track: {
          show: true,
          strokeWidth: '100%',
          opacity: 0.1,
          margin: 5,
        },
      },
    },
    fill: {
      type: 'solid',
    },
    labels: ['Stripe', 'PayPal', 'Airtel Money', 'TNM Mpamba'],
  };
  
  

export default function MultiRingChart({ gatewayStats }: { gatewayStats: GatewayStatsSummary }) {
    const series = [gatewayStats.stripe, gatewayStats.paypal, gatewayStats.airtel_money, gatewayStats.mpamba];
  return <Chart options={options} series={series} type="radialBar" height={290} />;
}
